/* Keep the existing WhatsApp link clear of the mobile purchase bar. */
(() => {
  const contact = document.getElementById('aurey-whatsapp-float');
  if (!contact) return;
  const mobile = window.matchMedia('(max-width: 749px)');
  let frame = 0;
  let observedBar = null;
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resize = new ResizeObserver(schedule);
  function update() {
    frame = 0;
    const overlayOpen = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden]):not([aria-hidden="true"])')).some(el => {
      const style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
    });
    contact.dataset.overlayOpen = String(overlayOpen);
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar !== observedBar) {
      if (observedBar) resize.unobserve(observedBar);
      observedBar = bar;
      if (bar) resize.observe(bar);
    }
    let clearance = 0;
    if (mobile.matches && bar && bar.dataset.stuck === 'true') {
      const host = bar.closest('sticky-add-to-cart');
      const style = getComputedStyle(bar);
      if (host?.dataset.variantAvailable === 'true' && style.display !== 'none' && style.visibility !== 'hidden') {
        // Use full height, including while the bar is animating into view.
        clearance = Math.ceil(bar.offsetHeight + Math.max(0, parseFloat(style.bottom) || 0) + 4);
      }
    }
    contact.style.setProperty('--aurey-purchase-clearance', clearance + 'px');
  }
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['data-stuck', 'data-variant-available', 'open', 'hidden', 'aria-hidden', 'aria-modal']
  });
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
